<div class="w-[450px]">
  <div class="grid">
    <div class="flex flex-col justify-between">
      <aux-download-template-button
        label="{{
          type === 'UPLOAD' ? 'Download Bulk PO Template' : 'Template to Bulk Update POs'
        }}"
        classList="pl-0"
        fileName="{{
          type === 'UPLOAD'
            ? 'auxilius-template-BULK_UPLOAD_PURCHASE_ORDERS'
            : 'auxilius-template-BULK_UPDATE_PURCHASE_ORDERS'
        }}"
        [templateType]="type === 'UPLOAD' ? uploadTemplateType : updateTemplateType"
      />
      @if (type === 'UPDATE') {
        <aux-download-template-button
          label="Template to Bulk Update POs (all {{
            isCurrentTrialCMC ? 'workspaces' : 'trials'
          }})"
          class="mb-4"
          classList="pl-0"
          fileName="auxilius-template-BULK_UPDATE_PURCHASE_ORDERS_all"
          [templateType]="updateAllTrialsTemplateType"
        />
      }

      <div class="mb-4">
        <div class="mb-1">Upload Template</div>

        <aux-file-manager
          #manager
          class="h-48"
          [fetchFilesOnInit]="false"
          [pathFn]="pathFn"
          [eager]="false"
          [metadata]="metadata"
          [showSuccessOnUpload]="true"
          [accept]="'.csv'"
          [extensions]="['text/csv']"
        />

        @if (fileManager?.fileQuery?.selectAll() | async; as files) {
          @if (files.length) {
            @for (file of files; track file; let last = $last) {
              <div class="flex items-center justify-between py-2" [ngClass]="{ 'border-b': !last }">
                <div class="items-start break-all text-xs">
                  {{ file.fileName }}
                </div>

                <button
                  class="btn h-6 w-6 rounded-full border-0 p-0 shadow-none"
                  type="button"
                  (click)="removeFile(file)"
                >
                  <aux-icon name="Trash" class="text-aux-error" />
                </button>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
